module.exports = __webpack_public_path__ + "img/full_logo.e8ee6285.png";